// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zdvT5","title":"Info_title__3EUjd","links":"Info_links__1KIEr","link":"Info_link__2WgFg","logo":"Info_logo__2PVma"};